var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockchainDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6029 4.81747C36.9656 1.43809 25.0049 2.72197 18.3951 8.75622C13.7281 13.0168 17.3403 14.2312 20.5221 22.0275C22.825 27.6701 0 26.8935 0 37.0895C0 48.8768 16.5314 46.6425 22.6661 47.9917C32.0456 50.0547 40.2281 57.772 50.2496 56.7546C58.974 55.8688 62.3 49.0227 63.5132 41.1743C65.7735 26.5523 60.2221 10.5375 45.6029 4.81747Z",
    fill: "url(#paint0_linear_3648_148039)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.5356 19.8065L54.0436 17.5753C56.6726 16.5622 58.5308 14.0865 58.5308 11.1909C58.5308 7.39392 55.3372 4.31592 51.3976 4.31592C47.458 4.31592 44.2643 7.39392 44.2643 11.1909C44.2643 14.1354 46.1855 16.6464 48.8852 17.626L43.518 19.8067V23.3319L39.9217 21.8708L40.0305 21.8267V11.7405L32.0215 8.48654L24.0126 11.7404V21.8265L24.081 21.8543L20.4826 23.3163V19.8065L12.4737 16.5527L4.46484 19.8065V29.472C4.46484 29.7264 4.61897 29.9553 4.85459 30.051L12.4737 33.1465L17.9826 30.9084V35.3848L12.4737 33.1465L4.46484 36.4004V46.0659C4.46484 46.3203 4.61897 46.5492 4.85459 46.6449L7.58572 47.7545C6.27934 49.0007 5.46947 50.7293 5.46947 52.6407C5.46947 56.4377 8.66309 59.5157 12.6027 59.5157C16.5423 59.5157 19.736 56.4377 19.736 52.6407C19.736 50.6914 18.8928 48.9329 17.5406 47.6818L20.4823 46.4865V42.9769L24.1268 44.4577L24.0103 44.505V54.1705C24.0103 54.4249 24.1645 54.6538 24.4001 54.7495L32.0192 57.845L39.6383 54.7495C39.874 54.6538 40.0281 54.4248 40.0281 54.1705V44.505L39.8732 44.4422L43.5177 42.9614V46.0659C43.5177 46.3203 43.6718 46.5492 43.9075 46.6449L51.5266 49.7404L59.1457 46.6449C59.3813 46.5492 59.5355 46.3202 59.5355 46.0659V36.4004L51.5266 33.1465L45.9793 35.4003V30.8928L51.5265 33.1465L59.1456 30.051C59.3812 29.9553 59.5353 29.7263 59.5353 29.472V19.8065H59.5356Z",
    fill: "#9C4FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0206 5.48633L24.0117 8.74008L32.0206 11.994L40.0295 8.74008L32.0206 5.48633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0284 18.8265L32.0195 22.0804V11.9941L40.0284 8.74023V18.8265Z",
    fill: "#DDC2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5508 13.5381V13.5525",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5234 12.7881V12.8025",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0206 11.9941L24.0117 8.74023V18.8265L32.0206 22.0804V11.9941Z",
    fill: "#DDC2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0206 5.48633L24.0117 8.74008L32.0206 11.994L40.0295 8.74008L32.0206 5.48633Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0284 18.8265L32.0195 22.0804V11.9941L40.0284 8.74023V18.8265Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0206 11.9941L24.0117 8.74023V14.9857",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5284 13.5527L43.5195 16.8066L51.5284 20.0605L59.5373 16.8066L51.5284 13.5527Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5362 26.8928L51.5273 30.1466V20.0605L59.5362 16.8066V26.8928Z",
    fill: "#DDC2FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7969 21.5947V21.6091",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7695 20.8447V20.8591",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5284 20.0605L43.5195 16.8066V26.8928L51.5284 30.1466V20.0605Z",
    fill: "#DDC2FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5284 13.5527L43.5195 16.8066L51.5284 20.0605L59.5373 16.8066L51.5284 13.5527Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5362 26.8928L51.5273 30.1466V20.0605L59.5362 16.8066V26.8928Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5284 20.0605L43.5195 16.8066V26.8928L51.5284 30.1466V20.0605Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 13.5522L4.46484 16.8061L12.4737 20.06L20.4826 16.8061L12.4737 13.5522Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4815 26.8923L12.4727 30.1462V20.06L20.4815 16.8062V26.8923Z",
    fill: "#DDC2FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7422 21.5938V21.6081",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 20.8438V20.8581",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 20.06L4.46484 16.8062V26.8923L12.4737 30.1462V20.06Z",
    fill: "#DDC2FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 13.5522L4.46484 16.8061L12.4737 20.06L20.4826 16.8061L12.4737 13.5522Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4815 26.8923L12.4727 30.1462V20.06L20.4815 16.8062V26.8923Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 20.06L4.46484 16.8062V26.8923L12.4737 30.1462V20.06Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9829 15.6445L17.9844 21.3319L31.9829 27.0193L45.9813 21.3319L31.9829 15.6445Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9828 38.9614L31.9844 44.6487V27.0194L45.9828 21.332V38.9614Z",
    fill: "#DDC2FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9829 27.0194L17.9844 21.332V38.9614L31.9829 44.6487V27.0194Z",
    fill: "#DDC2FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9829 15.6445L17.9844 21.3319L31.9829 27.0193L45.9813 21.3319L31.9829 15.6445Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9828 38.9614L31.9844 44.6487V27.0194L45.9828 21.332V38.9614Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9829 27.0194L17.9844 21.332V38.9614L31.9829 44.6487V27.0194Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0205 38.251L24.0117 41.5049L32.0205 44.7587L40.0293 41.5049L32.0205 38.251Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0284 51.591L32.0195 54.8449V44.7588L40.0284 41.5049V51.591Z",
    fill: "#DDC2FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5508 46.1445V46.1589",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5234 45.3945V45.4089",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0205 44.7588L24.0117 41.5049V51.591L32.0205 54.8449V44.7588Z",
    fill: "#DDC2FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0205 38.251L24.0117 41.5049L32.0205 44.7587L40.0293 41.5049L32.0205 38.251Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0284 51.591L32.0195 54.8449V44.7588L40.0284 41.5049V51.591Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0205 44.7588L24.0117 41.5049V51.591L32.0205 54.8449V44.7588Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.543 28.5508V28.5652",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5156 27.8008V27.8152",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5284 30.1465L43.5195 33.4004L51.5284 36.6542L59.5373 33.4004L51.5284 30.1465Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5362 43.4865L51.5273 46.7404V36.6543L59.5362 33.4004V43.4865Z",
    fill: "#DDC2FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7969 38.1885V38.2029",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7695 37.4385V37.4529",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5284 36.6543L43.5195 33.4004V43.4865L51.5284 46.7404V36.6543Z",
    fill: "#DDC2FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5284 30.1465L43.5195 33.4004L51.5284 36.6542L59.5373 33.4004L51.5284 30.1465Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4912 44.3174L59.5362 43.4865V33.4004L51.5273 36.6543V46.7404L53.8511 45.7964",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5284 36.6543L43.5195 33.4004V43.4865L51.5284 46.7404V36.6543Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 30.1465L4.46484 33.4004L12.4737 36.6542L20.4826 33.4004L12.4737 30.1465Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4815 43.4865L12.4727 46.7404V36.6543L20.4815 33.4004V43.4865Z",
    fill: "#DDC2FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7422 38.1885V38.2029",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 37.4385V37.4529",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 36.6543L4.46484 33.4004V43.4865L12.4737 46.7404V36.6543Z",
    fill: "#DDC2FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 30.1465L4.46484 33.4004L12.4737 36.6542L20.4826 33.4004L12.4737 30.1465Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4815 43.4865L12.4727 46.7404V36.6543L20.4815 33.4004V43.4865Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 36.6543L4.46484 33.4004V43.4865L12.4737 46.7404V36.6543Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.602 56.5156C16.5416 56.5156 19.7352 53.4376 19.7352 49.6406C19.7352 45.8437 16.5416 42.7656 12.602 42.7656C8.66241 42.7656 5.46875 45.8437 5.46875 49.6406C5.46875 53.4376 8.66241 56.5156 12.602 56.5156Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.602 56.5156C16.5416 56.5156 19.7352 53.4376 19.7352 49.6406C19.7352 45.8437 16.5416 42.7656 12.602 42.7656C8.66241 42.7656 5.46875 45.8437 5.46875 49.6406C5.46875 53.4376 8.66241 56.5156 12.602 56.5156Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7463 51.0902C11.577 51.0902 12.2504 50.4411 12.2504 49.6405C12.2504 48.8399 11.577 48.1909 10.7463 48.1909C9.91561 48.1909 9.24219 48.8399 9.24219 49.6405C9.24219 50.4411 9.91561 51.0902 10.7463 51.0902Z",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 49.6406H15.9598V50.9695",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 49.6406V50.9695",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M51.395 15.0659C55.3346 15.0659 58.5282 11.9879 58.5282 8.19092C58.5282 4.39396 55.3346 1.31592 51.395 1.31592C47.4554 1.31592 44.2617 4.39396 44.2617 8.19092C44.2617 11.9879 47.4554 15.0659 51.395 15.0659Z",
    fill: "#DDC2FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.395 15.0659C55.3346 15.0659 58.5282 11.9879 58.5282 8.19092C58.5282 4.39396 55.3346 1.31592 51.395 1.31592C47.4554 1.31592 44.2617 4.39396 44.2617 8.19092C44.2617 11.9879 47.4554 15.0659 51.395 15.0659Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5393 9.64046C50.37 9.64046 51.0434 8.99144 51.0434 8.19084C51.0434 7.39023 50.37 6.74121 49.5393 6.74121C48.7086 6.74121 48.0352 7.39023 48.0352 8.19084C48.0352 8.99144 48.7086 9.64046 49.5393 9.64046Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M51.043 8.19092H54.7527V9.51967",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M52.957 8.19092V9.51967",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0391 54.5674C48.7639 54.5674 49.3516 53.9798 49.3516 53.2549C49.3516 52.53 48.7639 51.9424 48.0391 51.9424C47.3142 51.9424 46.7266 52.53 46.7266 53.2549C46.7266 53.9798 47.3142 54.5674 48.0391 54.5674Z",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1133 3.73486C17.8382 3.73486 18.4258 3.14724 18.4258 2.42236C18.4258 1.69749 17.8382 1.10986 17.1133 1.10986C16.3884 1.10986 15.8008 1.69749 15.8008 2.42236C15.8008 3.14724 16.3884 3.73486 17.1133 3.73486Z",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 9.08008C13.1975 9.08008 13.7852 8.49245 13.7852 7.76758C13.7852 7.0427 13.1975 6.45508 12.4727 6.45508C11.7478 6.45508 11.1602 7.0427 11.1602 7.76758C11.1602 8.49245 11.7478 9.08008 12.4727 9.08008Z",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3438 55.8623L42.0938 57.1123",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 2.69531L40.9375 3.94531",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3648_148039",
    x1: 13.8456,
    y1: 55.4614,
    x2: 55.3229,
    y2: 13.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainDevelopment);
export default __webpack_public_path__ + "static/media/blockchainDevelopment.23a4602c770a1199bb98c9f4811f312a.svg";
export { ForwardRef as ReactComponent };